"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // MIME types from : https://www.lifewire.com/mime-types-by-content-type-3469108
    // Videos
    asf: 'video/x-ms-asf',
    asr: 'video/x-ms-asf',
    asx: 'video/x-ms-asf',
    avi: 'video/x-msvideo',
    lsf: 'video/x-la-asf',
    lsx: 'video/x-la-asf',
    mov: 'video/quicktime',
    mp2: 'video/mpeg',
    mp4: 'video/mp4',
    mpa: 'video/mpeg',
    mpe: 'video/mpeg',
    mpeg: 'video/mpeg',
    mpg: 'video/mpeg',
    mpv2: 'video/mpeg',
    qt: 'video/quicktime',
    // Images
    bmp: 'image/bmp',
    cmx: 'image/x-cmx',
    cod: 'image/cis-cod',
    gif: 'image/gif',
    ico: 'image/x-icon',
    ief: 'image/ief',
    jfif: 'image/pipeg',
    jpe: 'image/jpeg',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    heif: 'image/heif',
    heic: 'image/heic',
    pbm: 'image/x-portable-bitmap',
    pgm: 'image/x-portable-graymap',
    png: 'image/png',
    pnm: 'image/x-portable-anymap',
    ppm: 'image/x-portable-pixmap',
    ras: 'image/x-cmu-raster',
    rgb: 'image/x-rgb',
    svg: 'image/svg+xml',
    tif: 'image/tiff',
    tiff: 'image/tiff',
    xbm: 'image/x-xbitmap',
    xpm: 'image/x-xpixmap',
    // MIME types from https://stackoverflow.com/questions/43473056/which-mime-type-should-be-used-for-a-raw-image
    arw: 'image/x-sony-arw',
    cr2: 'image/x-canon-cr2',
    crw: 'image/x-canon-crw',
    dcr: 'image/x-kodak-dcr',
    dng: 'image/x-adobe-dng',
    erf: 'image/x-epson-erf',
    k25: 'image/x-kodak-k25',
    kdc: 'image/x-kodak-kdc',
    mrw: 'image/x-minolta-mrw',
    nef: 'image/x-nikon-nef',
    orf: 'image/x-olympus-orf',
    pef: 'image/x-pentax-pef',
    raf: 'image/x-fuji-raf',
    raw: 'image/x-panasonic-raw',
    sr2: 'image/x-sony-sr2',
    srf: 'image/x-sony-srf',
    x3f: 'image/x-sigma-x3f',
    // Document
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    csv: 'text/csv',
    html: 'text/html',
    // Fallback
    default: 'application/octet-stream',
};
//# sourceMappingURL=fileMimeTypes.js.map